import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, Redirect } from 'react-router-dom';
import { getInt } from 'utils/functions';
import FolderDocumentsContainer from '../../edit/documents/components/FolderDocumentsContainer';
import AddRemoveFinancedOffersContainer from '../../edit/generalData/financedOffers/components/AddRemoveFinancedOffersContainer';
import FolderScoringSessionHistoryContainer from 'features/folder/edit/scoringHistory/components/FolderScoringSessionHistoryContainer';
import FolderCheckListContainer from 'features/folder/edit/checklist/FolderCheckListContainer';
import DocumentsHistory from 'features/document/edit/documents/components/DocumentsHistory';
import DocumentPropertiesContainer from 'features/document/edit/documentProperties/components/DocumentPropertiesContainer';
import DocumentVerificationContainer from '../../../document/edit/verification/components/DocumentVerificationContainer';
import StateTransitionsContainer from 'features/document/edit/stateTransitions/components/StateTransitionsContainer';
import FacilityApprovalContainer from 'features/folder/edit/facility/FacilityApprovalContainer';
import DocumentComments from 'features/offer/edit/sidebar/components/comments/DocumentComments';
import documentTypeIds from 'constants/documentTypeIds';
import WrappedFakeText from 'components/common/WrappedFakeText';
import DocumentUploadPreviewModal from 'features/document/edit/documents/components/DocumentUploadPreviewModal';

const WorkflowContainer = React.lazy(() => import('components/offer/edit/workflow/components/WorkflowContainer'));

const FolderSwitcher = ({
  folderGeneralDataContainer,
  createFolderContainer,
  folderExposureContainer,
  folderScoringContainer,
  folderDecisionContainer,
  folderScoringHistoryContainer,
  onChangeActiveStep,
  folderContractGenerationContainer,
  history
}) => (
  <Switch>
    <Route exact path='/folders/:documentId(\d+)/:siteId(\d+)' render={() => <WrappedFakeText onPaper />} />
    <Route exact path='/folders/new' render={createFolderContainer} />
    <Route exact path='/folders/facilityApproval/new' render={createFolderContainer} />
    <Route exact path='/folders/:documentId(\d+)/:siteId(\d+)/generalData' render={folderGeneralDataContainer} />
    <Route exact path='/folders/:documentId(\d+)/:siteId(\d+)/exposure' render={folderExposureContainer} />
    <Route exact path='/folders/:documentId(\d+)/:siteId(\d+)/scoring' render={folderScoringContainer} />
    <Route exact path='/folders/:documentId(\d+)/:siteId(\d+)/historyscoring' render={folderScoringHistoryContainer} />
    <Route
      exact
      path='/folders/:documentId(\d+)/:siteId(\d+)/:sessionID([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})/historyscoringsession'
      render={route => (
        <FolderScoringSessionHistoryContainer
          documentId={getInt(route.match.params.documentId)}
          siteId={getInt(route.match.params.siteId)}
          sessionID={route.match.params.sessionID}
        />
      )}
    />
    <Route exact path='/folders/:documentId(\d+)/:siteId(\d+)/decision' render={folderDecisionContainer} />
    <Route exact path='/folders/:documentId(\d+)/:siteId(\d+)/contractGeneration' render={folderContractGenerationContainer} />
    <Route
      exact
      path='/folders/:documentId(\d+)/:siteId(\d+)/facilityConfiguration/'
      render={route => <FacilityApprovalContainer folderId={getInt(route.match.params.documentId)} history={history} />}
    />
    <Route
      exact
      path='/folders/:documentId(\d+)/:siteId(\d+)/documents'
      render={route => (
        <FolderDocumentsContainer
          documentId={getInt(route.match.params.documentId)}
          siteId={getInt(route.match.params.siteId)}
          onChangeActiveStep={onChangeActiveStep}
          history={history}
        />
      )}
    />
    <Route
      exact
      path='/folders/:documentId(\d+)/:siteId(\d+)/documents/:fileId([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})'
      render={route => <DocumentUploadPreviewModal fileId={route.match.params.fileId} open={true} openFromRoute={true} />}
    />
    <Route
      exact
      path='/folders/:documentId(\d+)/:siteId(\d+)/documentHistory/:fileId([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})'
      render={route => <DocumentsHistory fileId={route.match.params.fileId} />}
    />
    <Route
      exact
      path='/folders/:documentId(\d+)/:siteId(\d+)/state-transitions'
      render={route => (
        <StateTransitionsContainer
          documentId={getInt(route.match.params.documentId)}
          siteId={getInt(route.match.params.siteId)}
          documentTypeId={documentTypeIds.Folder}
        />
      )}
    />
    <Route
      exact
      path='/folders/:documentId(\d+)/:siteId(\d+)/checklist'
      render={route => (
        <FolderCheckListContainer documentId={getInt(route.match.params.documentId)} siteId={getInt(route.match.params.siteId)} />
      )}
    />
    <Route
      exact
      path='/folders/:documentId(\d+)/:siteId(\d+)/workflows'
      render={route => <WorkflowContainer documentId={getInt(route.match.params.documentId)} siteId={getInt(route.match.params.siteId)} />}
    />
    <Route
      exact
      path='/folders/:documentId(\d+)/:siteId(\d+)/verifications'
      render={route => (
        <DocumentVerificationContainer
          documentId={getInt(route.match.params.documentId)}
          siteId={getInt(route.match.params.siteId)}
          isFolder
        />
      )}
    />
    <Route
      exact
      path='/folders/:documentId(\d+)/:siteId(\d+)/clientoffers/:clientId(\d+)'
      render={route => (
        <AddRemoveFinancedOffersContainer
          documentId={getInt(route.match.params.documentId)}
          siteId={getInt(route.match.params.siteId)}
          clientId={getInt(route.match.params.clientId)}
          isRemoveOffersMode={false}
        />
      )}
    />
    <Route
      exact
      path='/folders/:documentId(\d+)/:siteId(\d+)/removefinancedoffers/:clientId(\d+)'
      render={route => (
        <AddRemoveFinancedOffersContainer
          documentId={getInt(route.match.params.documentId)}
          siteId={getInt(route.match.params.siteId)}
          clientId={getInt(route.match.params.clientId)}
          isRemoveOffersMode={true}
        />
      )}
    />
    <Route
      exact
      path='/folders/:documentId(\d+)/:siteId(\d+)/document-properties'
      render={route => (
        <DocumentPropertiesContainer documentId={getInt(route.match.params.documentId)} siteId={getInt(route.match.params.siteId)} />
      )}
    />
    <Route
      exact
      path='/folders/:documentId(\d+)/:siteId(\d+)/comments'
      render={route => (
        <DocumentComments
          documentId={getInt(route.match.params.documentId)}
          siteId={getInt(route.match.params.siteId)}
          history={history}
          fullScreen={true}
        />
      )}
    />
    <Route render={() => <Redirect to='/notFound' />} />
  </Switch>
);

FolderSwitcher.propTypes = {
  folderGeneralDataContainer: PropTypes.func.isRequired,
  createFolderContainer: PropTypes.func.isRequired,
  folderExposureContainer: PropTypes.func.isRequired,
  folderScoringContainer: PropTypes.func.isRequired,
  folderDecisionContainer: PropTypes.func.isRequired,
  folderContractGenerationContainer: PropTypes.func.isRequired,
  folderScoringHistoryContainer: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  onChangeActiveStep: PropTypes.func.isRequired
};

export default FolderSwitcher;
